var exports = {
  "iU": "Message.module__message___LXRZZ2",
  "LU": "Message.module__swipeHost___LXRZZ2",
  "hw": "Message.module__swipeHostClipping___LXRZZ2",
  "WY": "Message.module__swipeReveal___LXRZZ2",
  "JI": "Message.module__swipeRevealLeft___LXRZZ2",
  "AO": "Message.module__swipeRevealRight___LXRZZ2",
  "Ph": "Message.module__messagePreviewSpacing___LXRZZ2",
  "IL": "Message.module__messagePreview___LXRZZ2",
  "Xo": "Message.module__messageHovered___LXRZZ2",
  "uK": "Message.module__focusRingAnchor___LXRZZ2",
  "J8": "Message.module__messageCompact___LXRZZ2",
  "L8": "Message.module__messageMentioned___LXRZZ2",
  "O8": "Message.module__messageReminded___LXRZZ2",
  "m6": "Message.module__messageReplying___LXRZZ2",
  "O6": "Message.module__messageHighlight___LXRZZ2",
  "lY": "Message.module__contextMenuActive___LXRZZ2",
  "Bc": "Message.module__mobileLayout___LXRZZ2",
  "p2": "Message.module__messageLongPress___LXRZZ2",
  "Uw": "Message.module__messageGrouped___LXRZZ2",
  "kT": "Message.module__messageEditing___LXRZZ2",
  "E4": "Message.module__messageSent___LXRZZ2",
  "mr": "Message.module__messageSending___LXRZZ2",
  "b$": "Message.module__messageFailed___LXRZZ2",
  "RZ": "Message.module__failedFooter___LXRZZ2",
  "Iu": "Message.module__failedFooterMessage___LXRZZ2",
  "bg": "Message.module__failedFooterLabel___LXRZZ2",
  "OZ": "Message.module__failedFooterIcon___LXRZZ2",
  "dv": "Message.module__failedRetryIcon___LXRZZ2",
  "QW": "Message.module__failedRetryButton___LXRZZ2",
  "q5": "Message.module__messageGutterLeft___LXRZZ2",
  "ZN": "Message.module__messageGutterRight___LXRZZ2",
  "$7": "Message.module__messageAvatar___LXRZZ2",
  "CW": "Message.module__messageNoText___LXRZZ2",
  "U7": "Message.module__messageContent___LXRZZ2",
  "rO": "Message.module__messageAuthorInfo___LXRZZ2",
  "xW": "Message.module__jumpHeading___LXRZZ2",
  "RO": "Message.module__jumpHeadingButton___LXRZZ2",
  "dw": "Message.module__messageAuthorRow___LXRZZ2",
  "AY": "Message.module__messageAuthorPart___LXRZZ2",
  "x": "Message.module__userTagOffset___LXRZZ2",
  "oL": "Message.module__messageTimestamp___LXRZZ2",
  "BK": "Message.module__authorDashSeparator___LXRZZ2",
  "um": "Message.module__messageUsername___LXRZZ2",
  "Lo": "Message.module__messageText___LXRZZ2",
  "L5": "Message.module__messageTimestampCompact___LXRZZ2",
  "tQ": "Message.module__compactAuthorPrefix___LXRZZ2",
  "U6": "Message.module__copyOnly___LXRZZ2",
  "Mz": "Message.module__compactInlineContent___LXRZZ2",
  "aM": "Message.module__systemMessageContent___LXRZZ2",
  "vp": "Message.module__contextMenuUnderline___LXRZZ2",
  "aE": "Message.module__messageTimeoutIndicator___LXRZZ2",
  "t4": "Message.module__textSeparator___LXRZZ2",
  "KL": "Message.module__messageTimestampHover___LXRZZ2",
  "jh": "Message.module__messageTimestampCompactHover___LXRZZ2",
  "iZ": "Message.module__messageAvatarCompact___LXRZZ2",
  "kq": "Message.module__compactContentWrapper___LXRZZ2",
  "xv": "Message.module__hoverAction___LXRZZ2",
  "kL": "Message.module__container___LXRZZ2",
  "tI": "Message.module__repliedMessage___LXRZZ2",
  "_T": "Message.module__repliedMessageCompact___LXRZZ2",
  "$y": "Message.module__repliedTextPreview___LXRZZ2",
  "NL": "Message.module__repliedAvatar___LXRZZ2",
  "a3": "Message.module__repliedIconContainer___LXRZZ2",
  "Pq": "Message.module__repliedIcon___LXRZZ2",
  "EK": "Message.module__repliedUsername___LXRZZ2",
  "IQ": "Message.module__repliedItalic___LXRZZ2",
  "t": "Message.module__unstyled___LXRZZ2",
  "Io": "Message.module__repliedTextContent___LXRZZ2",
  "c": "Message.module__systemMessageFollowsSystem___LXRZZ2",
  "Hj": "Message.module__systemMessageIconWrapper___LXRZZ2",
  "Po": "Message.module__systemMessageIconCompact___LXRZZ2",
  "jJ": "Message.module__systemMessageTimestamp___LXRZZ2",
  "rc": "Message.module__systemMessageContentWrapper___LXRZZ2",
  "V_": "Message.module__systemMessageCompactContent___LXRZZ2",
  "Gq": "Message.module__systemMessageIconSvg___LXRZZ2",
  "hr": "Message.module__systemMessageLink___LXRZZ2",
  "ll": "Message.module__userTagCompact___LXRZZ2",
  "O4": "Message.module__editedTimestamp___LXRZZ2",
  "k8": "Message.module__editedLabel___LXRZZ2",
  "zX": "Message.module__typingContainer___LXRZZ2",
  "Y9": "Message.module__typingCluster___LXRZZ2",
  "RL": "Message.module__typingIndicator___LXRZZ2",
  "Kl": "Message.module__typingAvatarContainer___LXRZZ2",
  "tY": "Message.module__typingText___LXRZZ2",
  "AZ": "Message.module__typingClusterComposerStatus___LXRZZ2",
  "am": "Message.module__compactContentNoPrefix___LXRZZ2",
  "Ys": "Message.module__compactBody___LXRZZ2",
  "Ac": "Message.module__unknownMessageCompactContent___LXRZZ2",
  "qU": "Message.module__unknownMessageWarning___LXRZZ2",
  "NG": "Message.module__keyboardFocused___LXRZZ2",
  "an": "Message.module__messageClientSystem___LXRZZ2",
  "og": "Message.module__systemMessageContainer___LXRZZ2",
  "Is": "Message.module__systemMessageIcon___LXRZZ2",
  "ry": "Message.module__mediaFocusRing___LXRZZ2",
  "xS": "Message.module__systemMessageDismissButton___LXRZZ2",
  "Eu": "Message.module__silentMessageIcon___LXRZZ2",
  "Fe": "Message.module__meEmote___LXRZZ2",
  "WU": "Message.module__compactInlineContentEmote___LXRZZ2",
  "Df": "Message.module__meEmoteAsterisk___LXRZZ2",
  "hs": "Message.module__meEmoteUsername___LXRZZ2",
  "fO": "Message.module__meEmoteAction___LXRZZ2",
  "Gy": "Message.module__meEmoteMeta___LXRZZ2",
  "tT": "Message.module__meEmoteTimestamp___LXRZZ2",
};

module.exports = exports;
